import { useEffect, useState } from 'react';
import './ComingSoon.css';
import { useNavigate } from 'react-router-dom';
import SideColumnScaffold from '../../ui/pageScaffolds/SideColumnScaffold/SideColumnScaffold';
import SideBarContent from '../../ui/panels/SideBars/SideBarContent/SideBarContent';
import { UserUtils } from '../../utils/UserUtils';

interface UserDetailObject {
  userName: string;
  id: string;
  email: string;
  role: string;
}

function ComingSoon(): JSX.Element {
  const nav = useNavigate();
  const [token, setToken] = useState<string>(
    localStorage.getItem('token') || ''
  );

  const [userDetails, setUserDetails] = useState<UserDetailObject>({
    userName: '',
    id: '',
    email: '',
    role: '',
  });

  useEffect(() => {
    if (token == '') {
      nav('/signin');
    }

    const userDetails = UserUtils.decodeUserToken(token);
    if (!userDetails) {
      nav('/signin');
    } else {
      setUserDetails(userDetails);
    }
  }, [token, nav]);

  const handleOnLogout = () => {
    localStorage.removeItem('token');
    nav('/signin');
  };

  return (
    <SideColumnScaffold
      sideBarContent={
        <SideBarContent
          nav={nav}
          userRole={userDetails.role}
          currentPath={window.location.pathname}
          userName={userDetails.userName}
          onLogout={handleOnLogout}
        />
      }
      mainContent={
        <div className="coming-soon-container">
          <div className="coming-soon-content">
            <h1>Coming Soon</h1>
            <p>This page is under development. Please check back later.</p>
          </div>
        </div>
      }
    />
  );
}

export default ComingSoon;

